import AmbassadorForm from './AmbassadorForm';
import AmbassadorPerks from './AmbassadorPerks';
import BannerAmbassador from './BannerAmbassador';

const CollegeAmbassador = () => {
  return (
    <div className="text-center">
      <BannerAmbassador />
      <AmbassadorPerks />
      <AmbassadorForm />
    </div>
  );
};

export default CollegeAmbassador;
